import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$keys from "babel-runtime/core-js/object/keys";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _slicedToArray from "babel-runtime/helpers/slicedToArray";

var _this = this;

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

/* eslint-disable */
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { getCompanyId, setSpecialKeys, clearSpecialKeys, clearSpecial, getSpecialSetting, getSpecialSettingkeys, customCompanyInfo } from "jcb-token-kit";
import { customNavCompanyIds } from "../utils/constant";

var useCustomized = function useCustomized() {
  var history = useHistory();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1]; // 是否读取换壳数据


  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      resources = _useState4[0],
      setResources = _useState4[1]; // 换壳资源

  var isCompany = function isCompany() {
    var companyId = getCompanyId();
    // 为0时为个人登录
    return companyId && companyId != "0" && companyId !== 0 && companyId !== undefined;
  };
  var loadPage = function loadPage() {
    setIsLoading(true);
  };
  // 清空换壳相关数据缓存
  var clearCustomizedData = function clearCustomizedData() {
    clearSpecialKeys();
    clearSpecial();
    setIsLoading(true);
  };

  // 获取换壳数据
  var getResourcesData = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var keys, color, content, _color, _content;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getSpecialSetting(getCompanyId());

            case 2:
              keys = _context.sent;

              console.log(_Object$keys(keys).length, "Object.keys(keys).length ");

              if (!(_Object$keys(keys).length > 100)) {
                _context.next = 25;
                break;
              }

              _context.prev = 5;

              if (!(_Object$keys(keys).length === 0)) {
                _context.next = 9;
                break;
              }

              localStorage.removeItem("themeColor");
              return _context.abrupt("return", clearCustomizedData());

            case 9:
              color = keys.color;

              if (color && color.value) {
                localStorage.setItem("themeColor", color.value);
              } else {
                localStorage.removeItem("themeColor");
              }
              localStorage.setItem("isSpecial", true);
              _context.next = 14;
              return getSpecialSettingkeys(getCompanyId(), _Object$keys(keys));

            case 14:
              content = _context.sent;

              setResources(content);
              setSpecialKeys(content);
              setIsLoading(true);
              _context.next = 23;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](5);

              clearCustomizedData();

            case 23:
              _context.next = 44;
              break;

            case 25:
              _context.prev = 25;

              if (!(_Object$keys(keys).length === 0)) {
                _context.next = 29;
                break;
              }

              localStorage.removeItem("themeColor");
              return _context.abrupt("return", clearCustomizedData());

            case 29:
              _color = keys.color;

              if (_color && _color.value) {
                localStorage.setItem("themeColor", _color.value);
              } else {
                localStorage.removeItem("themeColor");
              }
              localStorage.setItem("isSpecial", true);
              _context.next = 34;
              return getSpecialSettingkeys(getCompanyId(), _Object$keys(keys));

            case 34:
              _content = _context.sent;

              setResources(_content);
              setSpecialKeys(_content);
              setIsLoading(true);
              _context.next = 44;
              break;

            case 40:
              _context.prev = 40;
              _context.t1 = _context["catch"](25);

              clearCustomizedData();
              history.push("/404");

            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[5, 20], [25, 40]]);
    }));

    return function getResourcesData() {
      return _ref.apply(this, arguments);
    };
  }();
  var getData = function getData() {
    // 保险起见，如果当前不是正确的企业id ,清空换壳缓存
    // eslint-disable-next-line
    isCompany() ? getResourcesData() : clearCustomizedData();
  };
  // 判断是否是定制企业
  var checkIsCustomized = function checkIsCustomized(id) {
    return getSpecialSetting(id).then(function (data) {
      return _Object$keys(data).length !== 0;
    });
  };

  // 获取定制企业信息
  var getCustomCompany = function getCustomCompany() {
    return customNavCompanyIds.filter(function (v) {
      return v.id === getCompanyId();
    });
  };

  var getCompanySign = function getCompanySign() {
    if (isCompany()) {
      customCompanyInfo(getCompanyId()).then(function (data) {
        if (data) {
          if (data.customId && data.customId !== 0 && data.sign) {
            localStorage.setItem("sign", true);
          } else {
            localStorage.removeItem("sign");
          }
        } else {
          localStorage.removeItem("sign");
        }
      });
    } else {
      localStorage.removeItem("sign");
    }
  };

  return {
    isLoading: isLoading,
    setIsLoading: setIsLoading,
    resources: resources,
    getData: getData,
    getResourcesData: getResourcesData,
    clearCustomizedData: clearCustomizedData,
    checkIsCustomized: checkIsCustomized,
    getCustomCompany: getCustomCompany,
    getCompanySign: getCompanySign,
    isCompany: isCompany,
    loadPage: loadPage
  };
};

__signature__(useCustomized, "useHistory{history}\nuseState{[isLoading, setIsLoading](false)}\nuseState{[resources, setResources]({})}", function () {
  return [useHistory];
});

var _default = useCustomized;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useCustomized, "useCustomized", "src/components/useCustomized.js");
  reactHotLoader.register(_default, "default", "src/components/useCustomized.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();